/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `concert` - Concert
 * * `festival` - Festival
 * * `comedy` - Comedy Show
 * * `theater` - Theater
 * * `dance` - Dance Performance
 * * `spoken_word` - Spoken Word
 * * `private_event` - Private Event
 * * `other` - Other
 * @export
 */
export const ShowTypeEnum = {
    Concert: 'concert',
    Festival: 'festival',
    Comedy: 'comedy',
    Theater: 'theater',
    Dance: 'dance',
    SpokenWord: 'spoken_word',
    PrivateEvent: 'private_event',
    Other: 'other'
} as const;
export type ShowTypeEnum = typeof ShowTypeEnum[keyof typeof ShowTypeEnum];


export function instanceOfShowTypeEnum(value: any): boolean {
    for (const key in ShowTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(ShowTypeEnum, key)) {
            if (ShowTypeEnum[key as keyof typeof ShowTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ShowTypeEnumFromJSON(json: any): ShowTypeEnum {
    return ShowTypeEnumFromJSONTyped(json, false);
}

export function ShowTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowTypeEnum {
    return json as ShowTypeEnum;
}

export function ShowTypeEnumToJSON(value?: ShowTypeEnum | null): any {
    return value as any;
}

export function ShowTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ShowTypeEnum {
    return value as ShowTypeEnum;
}

